import React from "react";

export const IconRowColumn = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="17"
            height="17"
            viewBox="0 0 17 17"
        >
            <g id="line-chart" transform="translate(-4 0) rotate(90)">
                <g id="view_agenda" transform="translate(0 -4)">
                    <g
                        id="Path_360"
                        data-name="Path 360"
                        transform="translate(0 -17)"
                        fill="rgba(255,255,255,0)"
                    >
                        <path
                            d="M 16.10000038146973 16.10000038146973 L 0.8999999761581421 16.10000038146973 L 0.8999999761581421 0.8999999761581421 L 16.10000038146973 0.8999999761581421 L 16.10000038146973 16.10000038146973 Z"
                            stroke="none"
                        />
                        <path
                            d="M 1.800000190734863 1.800000190734863 L 1.800000190734863 15.19999980926514 L 15.19999980926514 15.19999980926514 L 15.19999980926514 1.800000190734863 L 1.800000190734863 1.800000190734863 M 0 0 L 17 0 L 17 17 L 0 17 L 0 0 Z"
                            stroke="none"
                            fill="currentColor"
                        />
                    </g>
                    <path
                        id="Path_359"
                        data-name="Path 359"
                        d="M0,0H14"
                        transform="translate(1.5 -8.5)"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.8"
                    />
                </g>
            </g>
        </svg>
    );
};
